import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import displayNames from '../displayNames';
import compose from '../../hoc/compose';
import DropDown from '../dropDown/dropDown';
import Footer from '../dropDown/dropDownChildren/dropDownStickyFooter';
import DropDownOption from '../dropDownOption/dropDownOption';
import SectionDivider from '../sectionDivider/sectionDivider';
var DEFAULT_EXAMPLES = {
  latin: '',
  'latin-ext': 'Gałąź',
  cyrillic: 'Пример',
  japanese: 'あア愛Aa',
  korean: '미리보기',
  arabic: 'مثال',
  hebrew: 'דוגמא'
};
var DEFAULT_FONT_GROUPS = {
  'my-uploads': 'My Fonts',
  latin: 'All Fonts',
  'latin-ext': 'Eastern European',
  cyrillic: 'Cyrillic',
  japanese: 'Japanese',
  korean: 'Korean',
  arabic: 'Arabic',
  hebrew: 'Hebrew'
};
var FontFamilyPicker = /*#__PURE__*/function (_React$Component) {
  function FontFamilyPicker(props) {
    var _this;
    _classCallCheck(this, FontFamilyPicker);
    _this = _callSuper(this, FontFamilyPicker, [props]);
    _this.fontExamplesMap = _.defaults(props.fontExamplesMap, DEFAULT_EXAMPLES);
    _this.fontGroupsNamesMap = _.defaults(props.fontGroupsNamesMap, DEFAULT_FONT_GROUPS);
    _this.state = {
      fontsItems: _this.getFontsItems(_this.props.fonts)
    };
    return _this;
  }
  _inherits(FontFamilyPicker, _React$Component);
  return _createClass(FontFamilyPicker, [{
    key: "getMissingFontName",
    value: function getMissingFontName() {
      if (this.isMissingFont()) {
        return this.props.getMissingFontName(this.props.value);
      }
    }
  }, {
    key: "getFontsItems",
    value: function getFontsItems(fontsArr) {
      var _this2 = this;
      var fontItems = [];
      _.forEach(fontsArr, function (lang) {
        fontItems.push({
          groupName: _this2.fontGroupsNamesMap[lang.lang]
        });
        _.forEach(lang.fonts, function (font) {
          if (font.permissions !== 'legacy') {
            var fontItem = {
              label: font.displayName,
              value: font.fontFamily,
              example: _this2.fontExamplesMap[lang.lang],
              cssFontFamily: font.cssFontFamily
            };
            fontItems.push(fontItem);
          }
        });
      });
      return fontItems;
    }
  }, {
    key: "isMissingFont",
    value: function isMissingFont() {
      return !_.find(this.state.fontsItems, {
        value: this.props.value
      });
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.fontExamplesMap = _.defaults(nextProps.fontExamplesMap, DEFAULT_EXAMPLES);
      this.fontGroupsNamesMap = _.defaults(nextProps.fontGroupsNamesMap, DEFAULT_FONT_GROUPS);
      if (!_.isEqual(this.props.fonts, nextProps.fonts)) {
        this.setState({
          fontsItems: this.getFontsItems(nextProps.fonts)
        });
      }
    }
  }, {
    key: "getInputStyle",
    value: function getInputStyle(item) {
      var _item$props;
      return item !== null && item !== void 0 && (_item$props = item.props) !== null && _item$props !== void 0 && _item$props.wasVisibleStyle ? {
        fontFamily: item.props.wasVisibleStyle.fontFamily
      } : {};
    }
  }, {
    key: "_makeFontItem",
    value: function _makeFontItem(fontItem) {
      return [fontItem.groupName ? /*#__PURE__*/React.createElement(SectionDivider, {
        key: fontItem.groupName
      }, this.props.translateIfNeeded(fontItem.groupName)) : null, fontItem.groupName ? null : /*#__PURE__*/React.createElement(DropDownOption, {
        key: fontItem.label + '_' + fontItem.cssFontFamily,
        value: fontItem.value,
        label: fontItem.label,
        wasVisibleStyle: {
          fontFamily: fontItem.cssFontFamily
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "font-option-container"
      }, /*#__PURE__*/React.createElement("span", {
        className: "font-label"
      }, fontItem.label), /*#__PURE__*/React.createElement("span", {
        className: "font-example"
      }, this.props.translateIfNeeded(fontItem.example))))];
    }
  }, {
    key: "_makeFooterLink",
    value: function _makeFooterLink(footerLink, footerLinkIndex) {
      return /*#__PURE__*/React.createElement("div", {
        key: footerLinkIndex,
        className: 'font-family-footer-link ' + (footerLink.className || ''),
        onClick: footerLink.onClick
      }, footerLink.symbol, /*#__PURE__*/React.createElement("span", null, this.props.translateIfNeeded(footerLink.label)));
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement.apply(this, [DropDown, {
        value: this.props.value,
        className: this.props.getClassName('control-font-family-picker ' + (this.props.toolbarMode ? 'toolbar-mode' : '') + (this.isMissingFont() ? 'missing-font' : '')),
        onChange: this.props.onChange,
        onToggle: this.props.onToggle,
        onOptionMouseEnter: this.props.onOptionMouseEnter,
        onArrowKeyDown: this.props.onArrowKeyDown,
        placeholder: this.getMissingFontName(),
        searchBox: true,
        groupedOptions: true,
        getInputStyle: this.props.shouldUseSelectedFontFamily ? this.getInputStyle.bind(this) : undefined,
        optionsContainerClassName: 'control-font-family-picker-options ' + (this.props.optionsContainerClassName || ''),
        shouldTranslate: false,
        shouldPassIsVisibleToOptions: true,
        automationId: this.props.automationId,
        dataHook: this.props.dataHook,
        disabled: this.props.disabled,
        hasArrowIcon: this.props.hasArrowIcon,
        optionsMaxHeight: this.props.optionsMaxHeight
      }, _.map(this.state.fontsItems, this._makeFontItem.bind(this)), this.props.footerLinks ? /*#__PURE__*/React.createElement(Footer, {
        closeOnClick: true,
        key: "font_family_footer",
        className: "control-dropdown-sticky-footer font-family-footer"
      }, React.createElement.apply(this, ['div', {
        className: 'footer-links-container fonts-upload'
      }, _.map(this.props.footerLinks, this._makeFooterLink.bind(this))])) : null]);
    }
  }]);
}(React.Component);
FontFamilyPicker.displayName = displayNames.FONT_FAMILY_PICKER;
FontFamilyPicker.defaultProps = {
  toolbarMode: false
};
FontFamilyPicker.propTypes = {
  className: PropTypes.string,
  /** Font value. */
  value: PropTypes.string,
  /** Change handler. */
  onChange: PropTypes.func,
  /** Callback called on dropdown toggle */
  onToggle: PropTypes.func,
  /** Callback called on dropdown option mouseenter */
  onOptionMouseEnter: PropTypes.func,
  /** Callback called on arrow key down */
  onArrowKeyDown: PropTypes.func,
  /** Footer links shown in the bottom of picker's dropdown. */
  footerLinks: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    symbol: PropTypes.element,
    className: PropTypes.string
  })),
  /** Fonts for picker. */
  fonts: PropTypes.arrayOf(PropTypes.shape({
    fonts: PropTypes.arrayOf(PropTypes.shape({
      cssFontFamily: PropTypes.string.isRequired,
      displayName: PropTypes.string.isRequired,
      fontFamily: PropTypes.string.isRequired,
      permissions: PropTypes.string
    }).isRequired),
    lang: PropTypes.string
  }).isRequired),
  /** A callback function, should return a string value. Will be called when `value` prop is not provided or is an illegal font value  */
  getMissingFontName: PropTypes.func.isRequired,
  /** Enables toolbar mode for control. */
  toolbarMode: PropTypes.bool,
  /** Should the values be translated using the translation context */
  shouldTranslate: PropTypes.bool,
  /** A collection to override the default groups names. Input example: `{latin: 'All Fonts', cyrillic: 'Cyrillic'}` */
  fontGroupsNamesMap: PropTypes.object,
  /** A collection to override the default font examples. Input example: `{arabic: 'مثال', cyrillic: 'Пример'}` */
  fontExamplesMap: PropTypes.object,
  /** Disables picker. */
  disabled: PropTypes.bool,
  /** Shows arrow icon on end of the picker. */
  hasArrowIcon: PropTypes.bool,
  /** Sets the options to the given height **/
  optionsMaxHeight: PropTypes.number
};
export default compose(FontFamilyPicker);